import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { brandPrimary, darkGrayFontColor, navigation, titles, white } from '../../../../web/styles/colors';

export const s = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		maxWidth: 320,
		width: '100%',
		backgroundColor: white,
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		padding: '12px 16px',
		borderBottom: THEME.common.border,
	},
	meetingName: {
		fontSize: 14,
		fontWeight: THEME.typography.fontWeights.bold,
		color: titles,
		margin: 0,
	},
	meetingMeta: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 12,
		color: darkGrayFontColor,
	},
	metaSeparator: {
		width: 3,
		height: 3,
		borderRadius: '50%',
		backgroundColor: navigation,
		flexShrink: 0,
	},
	calendarSection: {
		padding: '8px 4px',
		display: 'flex',
		justifyContent: 'center',
	},
	compactCalendar: {
		'--cell-size': 40,
		padding: 8,
	},
	slotsSection: {
		padding: '0 16px 12px',
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	slotsLabel: {
		fontSize: 12,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: darkGrayFontColor,
	},
	slotsGrid: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 6,
		maxHeight: 160,
		overflowY: 'auto',
	},
	slotButton: {
		fontSize: 13,
		padding: '6px 12px',
		borderRadius: 6,
		border: `1px solid ${brandPrimary}`,
		backgroundColor: white,
		color: brandPrimary,
		cursor: 'pointer',
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontWeight: THEME.typography.fontWeights.standard,
		transition: 'background-color 0.15s, color 0.15s',
		':hover': {
			backgroundColor: `${brandPrimary}0d`,
		},
	},
	slotButtonSelected: {
		backgroundColor: brandPrimary,
		color: white,
		':hover': {
			backgroundColor: brandPrimary,
		},
	},
	confirmRow: {
		padding: '0 16px 12px',
	},
	confirmButton: {
		width: '100%',
	},
	noSlots: {
		fontSize: 13,
		color: darkGrayFontColor,
		padding: '4px 0',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: '16px 0',
	},
	errorMessage: {
		fontSize: 13,
		color: darkGrayFontColor,
		padding: '16px',
		textAlign: 'center',
	},
	confirmedContainer: {
		padding: '12px 16px',
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 13,
		color: titles,
	},
	checkmark: {
		color: brandPrimary,
		flexShrink: 0,
		width: 16,
		height: 16,
	},
});
